import { deleteFloatingIpMutation } from "@/admin/floating_ips/floatingIpsQuery.ts";
import type { GQIpAddressItem } from "@/admin/floating_ips/FloatingIpsTable.tsx";
import { WModalContent } from "@/components/modal/WModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { notNull } from "@warrenio/utils/notNull";

interface DeleteFloatingIpModalProps {
    item: GQIpAddressItem;
}

export function DeleteFloatingIpModalContent({ item }: DeleteFloatingIpModalProps) {
    const deleteMutation = useStandardMutation(deleteFloatingIpMutation);
    const { address, _location } = item;

    async function onSubmit() {
        await deleteMutation.mutateAsync({
            address,
            location: notNull(_location),
        });
    }

    return (
        <WModalContent title="Delete Floating IP" label="Delete" autoFocus modalAction={async () => await onSubmit()}>
            <p>
                Deleting Floating IP "<b>{address}</b>" will remove this IP from current user.
            </p>
        </WModalContent>
    );
}
